import { IconProps } from ".";
import Icon from "./assets/chevron_left_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24ChevronLeft(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
